/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import {
  BfAppContext,
  BfPageStore,
  ConditionRuleDTO,
  EnumValue,
  newEqualCondition,
  newRuleCondition,
  newSortAsc,
  newSortDesc
} from '@tw/tw-runtime';
import { GiftGiftInfoLoadParam, GiftGiftInfoStoreState } from './type';
import {
  ProductDocGoodsRestApiService,
  ProductDocProductRestApiService,
  ProductGoodsDTO,
  ProductGoodsRestApiService,
  ProductOnGoingWelfareModel,
  ProductProductRestApiService,
  ProductTypeEnumValue,
  ResAddressDTO,
  ResAddressRestApiService,
  SaleDocOrderDTO,
  SaleDocOrderRestApiService
} from '@tw/clvip-api-gen';

import { ROUTE_NAMES } from '@/app/navigation/route-names';
import { TwSectionListRenderInfo } from '@tw/tw-runtime-react';

export class GiftGiftInfoStore extends BfPageStore<GiftGiftInfoStoreState> {
  private static instance = null;

  // 商品service
  private productResetService: ProductProductRestApiService;
  private productDocGoodsService: ProductDocGoodsRestApiService;
  private productService: ProductDocProductRestApiService;

  // 地址service
  private addressService: ResAddressRestApiService;

  // 商品service
  private productGoodsService: ProductGoodsRestApiService;
  private priceSort: 'asc' | 'desc' = 'desc';

  // 订单
  // private orderService: SaleOrderRestApiService;
  private orderDocService: SaleDocOrderRestApiService;

  private curActivity: ProductOnGoingWelfareModel;

  constructor() {
    super({
      pluginOptions: {
        devTools: {
          name: 'gift/gift-info'
        }
      }
    });
    const api = BfAppContext.getInstance().getApiService();
    this.productResetService = new ProductProductRestApiService(api);
    this.productDocGoodsService = new ProductDocGoodsRestApiService(api);
    this.productGoodsService = new ProductGoodsRestApiService(api);
    this.addressService = new ResAddressRestApiService(api);
    // this.orderService = new SaleOrderRestApiService(api);
    this.orderDocService = new SaleDocOrderRestApiService(api);
    this.productService = new ProductDocProductRestApiService(api);
  }

  public static getInstance(): GiftGiftInfoStore {
    if (!this.instance) {
      this.instance = new GiftGiftInfoStore();
    }
    return this.instance;
  }

  // 获取产品类型枚举
  getProductTypeEnum = async (): Promise<EnumValue[]> => {
    const enumService = BfAppContext.getInstance().getEnumService();
    const enums = await enumService.getEnumOptions(ProductTypeEnumValue._id);

    return enums;
  };

  // 初始化
  async onLoad(params?: GiftGiftInfoLoadParam): Promise<void> {
    console.log('param: ', params);
    if (!params) {
      return;
    }

    this.setLoading(true);
    let data;
    this.setState({
      detailType: params.detailType
    });
    if (params.detailType === 'product') {
      data = await this.productService.info({
        id: params.id
      });
    } else {
      data = await this.productDocGoodsService.info({
        id: params.id
      });
    }

    this.setState({
      data: data,
      editable: params.mode === 'edit'
    });

    this.setLoading(false);
  }
}
